import { useEffect } from 'react';
import { useSplitPane } from '../layout/SplitPaneLayout';

/**
 * RefinePanelOpener - Opens refine panel when shouldOpen prop is true
 * 
 * Used to open panel from callbacks (Find Similar, Refine Search)
 */
export default function RefinePanelOpener({ shouldOpen, onOpened }) {
  const { openPanel, isOpen } = useSplitPane();
  
  useEffect(() => {
    if (shouldOpen && !isOpen) {
      openPanel();
      if (onOpened) {
        onOpened();
      }
    }
  }, [shouldOpen, isOpen, openPanel, onOpened]);
  
  return null;
}
